import { useVariant } from '@calendly/feature-check-react'
import { useFormContext, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { useGetUserQuery } from 'common'
import { RichTextField } from 'components/core/form'
import { openUserAgreementPopup } from 'features/user_agreements'
import { getLocalizedVariableName } from 'services/get-localized-variable-name'

import { buildDefaultNotification, getBodySupportedFormatting, getDefaultFieldValue, localizeTemplateVariables } from './config'
import { SmsBodyField, isSmsNotification } from './sms_body_field'

export const BodyField = ({
  eventType,
  name,
  disabled,
  useUpdatedDisabledState = false,
  useUpdatedToolbarActions = false,
  openVariablesDropdownOnLeft = false,
  includeProTip = true,
  etLocked = false
}) => {
  const { values: { noReplyEnabled } } = useFormContext()
  const [{ value: { kind } }] = useFormField(name)
  const { data: currentUser } = useGetUserQuery()
  const aiFeaturesEnabled = ['enabled_multi_buttons'].includes(useVariant('ai_text_editor'))
  const dispatch = useDispatch()
  const showUserAgreement = (onAgree) => dispatch(openUserAgreementPopup({ name: 'ai_beta_terms', onAgree }))

  const defaultNotification = buildDefaultNotification(eventType, kind, { noReplyEnabled })

  const bodyTemplateVariables = useMemo(
    () => localizeTemplateVariables(defaultNotification.variables.body),
    [defaultNotification.variables.body]
  )

  const isSms = isSmsNotification(kind)
  const BodyFieldComponent = isSms ? SmsBodyField : RichTextField

  // i18n-tasks-use t('publisher.event_types.notifications.invitee_invitation.body_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_invitation.body_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_confirmation.body_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_confirmation.body_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_reminder.body_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_reminder.body_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_sms_reminder.body_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_sms_reminder.body_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_email_follow_up.body_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_email_follow_up.body_tip')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_cancellation.body_label')
  // i18n-tasks-use t('publisher.event_types.notifications.invitee_cancellation.body_tip')
  return (
    <BodyFieldComponent
      id="wysiwyg-body"
      name={`${name}.body`}
      label={I18n.t(`publisher.event_types.notifications.${kind}.body_label`)}
      proTip={includeProTip && !disabled && I18n.t(`publisher.event_types.notifications.${kind}.body_tip`)}
      disabled={disabled || etLocked}
      supportedFormatting={getBodySupportedFormatting(kind)}
      filterAliases
      useUpdatedDisabledState={useUpdatedDisabledState}
      useUpdatedToolbarActions={useUpdatedToolbarActions}
      openVariablesDropdownOnLeft={openVariablesDropdownOnLeft}
      getLocalizedVariableName={getLocalizedVariableName}
      templateVariables={bodyTemplateVariables}
      defaultContent={getDefaultFieldValue(defaultNotification, 'body')}
      aiFeaturesEnabled={aiFeaturesEnabled}
      editorUsageType={`${name}_body`}
      eventTypeId={eventType?.id}
      showUserAgreement={showUserAgreement}
      source="et"
      userId={currentUser?.id}
    />
  )
}
